import styled from "@emotion/styled";
import { Box, Button, Container, Stack } from "@mui/material";
import React from "react";
import { Location, useLocation, useNavigate } from "react-router-dom";
import { PromoLocationState } from "..";
import { VdsPageTitle } from "../../@vds";
import { useProfileContext } from "../../contexts";

export const StyledDescription = styled("p")(() => ({
    color: "#605f60",
    fontSize: "1rem",
    fontFamily: "Roboto",
    fontWeight: "normal",
    letterSpacing: "0.15px",
    lineHeight: "1.5rem"
}));

export const PromoPage = () => {

    const [profile] = useProfileContext();

    const navigate = useNavigate();

    const location: Location<PromoLocationState> = useLocation();
    const locationState = location.state;

    React.useEffect(() => {
        if (!profile?.oid) navigate('/login');
        else {
            window.aptrinsic("identify", {
                POC_HR_Token: locationState.POC_HR_Token,
                "id": locationState.audience.id,
                "email": locationState.audience.email,
                "firstName": locationState.audience.firstName,
                "lastName": locationState.audience.lastName,
            }, {
                "id": locationState.account.id,
                "name": locationState.account.name,
                "TSX_piva": locationState.account.tsX_piva,
            });
        }
    }, [locationState.POC_HR_Token, locationState.account, locationState.audience, navigate, profile?.oid]);

    const gainsightAction = React.useCallback((type: "POC_HR_Action3" | "POC_HR_Action2" | "POC_HR_Action1", campaignId?: string) => {

        window.aptrinsic("track", type, {
            campaignId: campaignId || locationState.POC_HR_CampaignOid,
        });
    }, [locationState]);

    const redirectToHome = React.useCallback(() => {
        navigate('/app');
    }, [navigate]);

    if (locationState) {
        return (
            <Container maxWidth="md" sx={{ height: 'calc(100vh - 100px)', overflow: 'auto' }} >
                <VdsPageTitle title="Riepilogo dati utente e company" />
                <StyledDescription>
                    <b>Utente Loggato:</b> <br />
                    [{profile?.oid}] {profile?.email} <br />
                    <b>Azienda utente:</b> <br />
                    [{locationState.account?.tsX_piva}] {locationState.account?.name} <br />
                    <b>Token:</b> <br />
                    {locationState.POC_HR_Token} <br />
                    <b>CampaignOid:</b> <br />
                    {locationState.POC_HR_CampaignOid} <br />
                </StyledDescription>
                <br />
                <br />
                <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                    <Button variant="outlined" color="primary" onClick={redirectToHome}>
                        Indietro
                    </Button>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => gainsightAction("POC_HR_Action1")}
                        >
                            Dialog
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => gainsightAction("POC_HR_Action2")}
                        >
                            Banner
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        );
    }

    return (
        <Box>
            Invalid company!
        </Box>
    );
};
